import { render, staticRenderFns } from "./k-gold-trace.vue?vue&type=template&id=28d4caac&scoped=true&"
import script from "./k-gold-trace.vue?vue&type=script&lang=js&"
export * from "./k-gold-trace.vue?vue&type=script&lang=js&"
import style0 from "./k-gold-trace.vue?vue&type=style&index=0&id=28d4caac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4caac",
  null
  
)

export default component.exports